// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dashboard-content {
  display: flex;
  flex: 1 1;
  flex-direction: column;
  overflow: auto;
}
.dashboard-content-container {
  margin: 1em;
  background-color: white;
  border: none;
  border-radius: 10px;
  padding: 1em;
  display: flex;
  flex-direction: column;
  gap: 25px;
  overflow: auto;
}
.dashboard-content-header {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.dashboard-content-header h2 {
  margin-top: auto;
  margin-bottom: auto;
  color: black;
  font-size: xx-large;
  font-weight: 700;
}
.dashboard-content-search {
  font-weight: 400;
  line-height: 1.4em;
  letter-spacing: 0.009em;
  box-sizing: border-box;
  cursor: text;
  display: inline-flex;
  align-items: center;
  position: relative;
  background-color: transparent;
  font-size: 0.875rem;
  border-radius: 0.375rem;
  border: 1px solid gray;
}
.dashboard-content-search:focus {
  outline: #2d83b5 auto 1px;
}
.dashboard-content-input {
  font-style: inherit;
  font-variant: inherit;
  font-weight: inherit;
  font-stretch: inherit;
  line-height: inherit;
  font-family: inherit;
  letter-spacing: inherit;
  border: 0px;
  box-sizing: content-box;
  background: none transparent;
  margin: 0px;
  display: block;
  min-width: 0px;
  width: 100%;
  color: #000000;
  font-size: 0.75rem;
  padding: 0.625rem;
}
table {
  width: 100%;
  margin: auto;
}
th {
  text-align: left;
  padding: 12px 24px;
  background: transparent;
  box-shadow: none;
  color: #2d83b5;
  font-size: 0.75rem;
  font-weight: 700;
  line-height: 1.25;
  letter-spacing: 0.035em;
  border-bottom: 0.05rem solid rgb(240, 242, 245);
}
tbody {
  display: table-row-group;
}
tr,
thead {
  color: inherit;
  display: table-row;
  vertical-align: middle;
  outline: 0px;
}
td {
  text-align: left;
  padding: 12px 24px;
  background: transparent;
  box-shadow: none;
  border-bottom: 0.05rem solid rgb(240, 242, 245);
}
td div {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.dashboard-content-avatar {
  width: 40px;
  height: 40px;
  margin-left: 10px;
  border-radius: 20px;
}
td span {
  margin: 0px;
  font-size: 0.75rem;
  line-height: 1.25;
  letter-spacing: 0.035em;
  opacity: 1;
  text-transform: none;
  vertical-align: unset;
  text-decoration: none;
  color: gray;
  font-weight: 700;
}
.dashboard-content-icon {
  width: 20px;
  margin-right: 10px;
}
.dashboard-content-footer {
  display: flex;
  flex-direction: row;
  justify-content: center;
}
.dashboard-content-footer .pagination {
  padding: 0.5rem;
  margin: 0.2rem;
  border-radius: 5px;
  background-color: #f0f2f5;
  cursor: pointer;
}
.dashboard-content-footer .active-pagination {
  padding: 0.5rem;
  margin: 0.2rem;
  border-radius: 5px;
  color: #ffffff;
  background-color: #2d83b5;
  cursor: pointer;
}
.empty-table {
  margin: 0px;
  font-size: 1rem;
  line-height: 1.25;
  letter-spacing: 0.035em;
  color: gray;
  font-weight: 700;
  border-color: #ffffff;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Reported-Nfts/styles.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,SAAO;EACP,sBAAsB;EACtB,cAAc;AAChB;AACA;EACE,WAAW;EACX,uBAAuB;EACvB,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,cAAc;AAChB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;AACA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,uBAAuB;EACvB,sBAAsB;EACtB,YAAY;EACZ,oBAAoB;EAEpB,mBAAmB;EACnB,kBAAkB;EAClB,6BAA6B;EAC7B,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;AACxB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,oBAAoB;EACpB,qBAAqB;EACrB,oBAAoB;EACpB,oBAAoB;EACpB,uBAAuB;EACvB,WAAW;EACX,uBAAuB;EACvB,4BAA4B;EAC5B,WAAW;EACX,cAAc;EACd,cAAc;EACd,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,uBAAuB;EACvB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,+CAA+C;AACjD;AACA;EACE,wBAAwB;AAC1B;AACA;;EAEE,cAAc;EACd,kBAAkB;EAClB,sBAAsB;EACtB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,uBAAuB;EACvB,gBAAgB;EAChB,+CAA+C;AACjD;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,uBAAuB;EACvB,UAAU;EACV,oBAAoB;EACpB,qBAAqB;EACrB,qBAAqB;EACrB,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;AACjB;AACA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,yBAAyB;EACzB,eAAe;AACjB;AACA;EACE,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,uBAAuB;EACvB,WAAW;EACX,gBAAgB;EAChB,qBAAqB;AACvB","sourcesContent":[".dashboard-content {\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  overflow: auto;\n}\n.dashboard-content-container {\n  margin: 1em;\n  background-color: white;\n  border: none;\n  border-radius: 10px;\n  padding: 1em;\n  display: flex;\n  flex-direction: column;\n  gap: 25px;\n  overflow: auto;\n}\n.dashboard-content-header {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n}\n.dashboard-content-header h2 {\n  margin-top: auto;\n  margin-bottom: auto;\n  color: black;\n  font-size: xx-large;\n  font-weight: 700;\n}\n.dashboard-content-search {\n  font-weight: 400;\n  line-height: 1.4em;\n  letter-spacing: 0.009em;\n  box-sizing: border-box;\n  cursor: text;\n  display: inline-flex;\n  -webkit-box-align: center;\n  align-items: center;\n  position: relative;\n  background-color: transparent;\n  font-size: 0.875rem;\n  border-radius: 0.375rem;\n  border: 1px solid gray;\n}\n.dashboard-content-search:focus {\n  outline: #2d83b5 auto 1px;\n}\n.dashboard-content-input {\n  font-style: inherit;\n  font-variant: inherit;\n  font-weight: inherit;\n  font-stretch: inherit;\n  line-height: inherit;\n  font-family: inherit;\n  letter-spacing: inherit;\n  border: 0px;\n  box-sizing: content-box;\n  background: none transparent;\n  margin: 0px;\n  display: block;\n  min-width: 0px;\n  width: 100%;\n  color: #000000;\n  font-size: 0.75rem;\n  padding: 0.625rem;\n}\ntable {\n  width: 100%;\n  margin: auto;\n}\nth {\n  text-align: left;\n  padding: 12px 24px;\n  background: transparent;\n  box-shadow: none;\n  color: #2d83b5;\n  font-size: 0.75rem;\n  font-weight: 700;\n  line-height: 1.25;\n  letter-spacing: 0.035em;\n  border-bottom: 0.05rem solid rgb(240, 242, 245);\n}\ntbody {\n  display: table-row-group;\n}\ntr,\nthead {\n  color: inherit;\n  display: table-row;\n  vertical-align: middle;\n  outline: 0px;\n}\ntd {\n  text-align: left;\n  padding: 12px 24px;\n  background: transparent;\n  box-shadow: none;\n  border-bottom: 0.05rem solid rgb(240, 242, 245);\n}\ntd div {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n}\n.dashboard-content-avatar {\n  width: 40px;\n  height: 40px;\n  margin-left: 10px;\n  border-radius: 20px;\n}\ntd span {\n  margin: 0px;\n  font-size: 0.75rem;\n  line-height: 1.25;\n  letter-spacing: 0.035em;\n  opacity: 1;\n  text-transform: none;\n  vertical-align: unset;\n  text-decoration: none;\n  color: gray;\n  font-weight: 700;\n}\n.dashboard-content-icon {\n  width: 20px;\n  margin-right: 10px;\n}\n.dashboard-content-footer {\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n}\n.dashboard-content-footer .pagination {\n  padding: 0.5rem;\n  margin: 0.2rem;\n  border-radius: 5px;\n  background-color: #f0f2f5;\n  cursor: pointer;\n}\n.dashboard-content-footer .active-pagination {\n  padding: 0.5rem;\n  margin: 0.2rem;\n  border-radius: 5px;\n  color: #ffffff;\n  background-color: #2d83b5;\n  cursor: pointer;\n}\n.empty-table {\n  margin: 0px;\n  font-size: 1rem;\n  line-height: 1.25;\n  letter-spacing: 0.035em;\n  color: gray;\n  font-weight: 700;\n  border-color: #ffffff;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
